<script context="module">
  import {writable} from 'svelte/store';

  const currentID$ = writable(null);

  let counter = 0;
</script>

<script>
  import {onMount, tick, createEventDispatcher} from 'svelte';
  import {SERVICES} from '@/const/services';
  import {mc} from '@/core';
  import {Icon} from '@/widgets/icon'

  let className = '';
  export {className as class};
  export let value = undefined;
  export let disabled = false;
  export let options = [];
  export let white = false;
  export let before = false;
  export let placeholder = '';
  export let displayText = '';
  export let label = '';
  export let type = 'underline';
  export let position = '';
  export let noSearch = false;
  export let setMaxWidth = false;
  export let showHover = false;
  export let optionsNode = null;
  export let showSearchMinLength = 0;
  export let size = 'normal'; // 'large'
  export let style = '';
  export let alwaysShowScrollBar = false;
  export let showOptionHeader = true;

  const dispatch = createEventDispatcher();
  const id = counter++;
  const searchIcon = SERVICES.STATIC_URL + '/pubimg/df0311663755adbe9938acd2470163f5391d54f1a4c39351c6cbfbef1839baa8.png';
  const arrowIcon = `${SERVICES.IMG_URL}/v1/397a10be-375c-49ac-8e96-fe90abd1d45a/arrow-bold.svg`;

  let showDropdown = false;
  let filterValue = '';
  let filterOptionsArr = [];
  let inputEl;
  let showIndex = -1;

  $: updateDisplayText(options, value);
  $: updateFilterValue(filterValue, options);

  onMount(() =>
    currentID$.subscribe((currentID) => {
      if (currentID === id) {
        return;
      }
      showDropdown = false;
    })
  );

  onMount(() => {
    document.addEventListener('click', hideDropdown);
    return () => document.removeEventListener('click', hideDropdown);
  });

  onMount(() => {
    mc.subscribe('close-selectSearch', 'close', () => {
      showDropdown = false;
    });
  });

  function hideDropdown() {
    showDropdown = false;
  }

  function handleSearchClick(e) {
    e.stopPropagation();
  }

  function updateDisplayText(options, value) {
    if (options.length < 1 || value === undefined) {
      displayText = placeholder;
      return;
    }
    const item = options.find((o) => o.value === value);
    if (item) {
      displayText = label ? `${label}：${item.text}` : item.text;
      return;
    }
    displayText = placeholder;
  }

  async function handleClickDownFun(e) {
    e.stopPropagation();
    if (disabled) {
      return;
    }
    dispatch('click');
    showDropdown = !showDropdown;
    if (showDropdown) {
      await tick();
      inputEl && inputEl.focus();
      currentID$.set(id);
    }
    mc.send('close-mobileSelect', 'close', true);
  }

  function handleClickFun(option) {
    return function () {
      value = option.value;
      showDropdown = !showDropdown;
      if (showDropdown) {
        currentID$.set(id);
      }
      dispatch('change', {value});
    };
  }

  function updateFilterValue(value, optionsArr) {
    value = !value ? value : value.trim().toLowerCase();
    filterOptionsArr = !value
      ? optionsArr
      : optionsArr.filter((o) => {
          if (o.email) {
            return o.text.toLowerCase().indexOf(value) > -1 || o.email.toLowerCase().indexOf(value) > -1;
          }
          return o.text.toLowerCase().indexOf(value) > -1;
        });
  }

  function handleShowHoverFun(index) {
    return function () {
      showIndex = index;
    };
  }
  function handleShowLeaveFun() {
    return function () {
      showIndex = -1;
    };
  }

  function handleClear() {
    filterValue = ''
  }
</script>

<style>
  .wrap {
    min-width: 100px;
    height: 40px;
    line-height: 40px;
  }
  .underline {
    border-bottom: 1px solid #e5e5e5;
  }
  .border {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 0 10px;
  }
  .no-border {
    border: none;
  }
  .white.wrap:hover,
  .white.wrap:focus {
    border-bottom-color: #0064c8;
  }
  .white span,
  .white .arrow {
    color: var(--B1);
  }
  .white.before span::before {
    position: absolute;
    top: 4px;
    left: -10px;
    font-size: 18px;
    color: var(--B1);
    content: '*';
    vertical-align: middle;
  }
  .underline:hover {
    border-color: var(--blue);
  }
  .wrap.disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .arrow {
    transition: transform 0.2s;
    margin-left: 12px;
  }
  ul {
    top: 39px;
    left: 0;
    display: none;
    width: 100%;
    min-width: 140px;
    max-height: 190px;
    background: var(--B2);
    overflow-x: hidden;
    overflow-y: auto;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  }
  ul.pos-left {
    left: 0;
    width: 240px;
  }
  ul.pos-right {
    right: 0;
    left: unset;
    width: 240px;
  }
  ul li {
    margin: 0;
    line-height: 38px;
    white-space: nowrap;
  }
  ul li:not(.search-li):hover {
    background: var(--CARD1);
  }
  ul li:active {
    color: var(--blue);
  }
  .search-li {
    padding: 8px;
  }
  .search-icon {
    top: 16px;
    left: 14px;
    width: 12px;
    height: 12px;
  }
  .opt-header:hover {
    background: var(--B3);
  }
  .search {
    border: 1px solid transparent;
    background: var(--CARD1);
    padding-left: 20px;
    width: 100%;
    height: 30px;
    outline: none;
    border-radius: 32px;
  }
  .no-search {
    display: none;
  }
  .dropdown {
    z-index: 99999;
    display: inline-block;
  }
  .always-show-scroll-bar::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  .always-show-scroll-bar::-webkit-scrollbar:vertical {
    width: 10px;
  }
  .always-show-scroll-bar::-webkit-scrollbar:horizontal {
    height: 10px;
  }
  .always-show-scroll-bar::-webkit-scrollbar-thumb {
    border: 2px solid #fff;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .animation {
    transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }
  .active {
    color: var(--blue);
  }
  .set-max-width {
    width: 140px;
  }
  .hover {
    bottom: 30px;
    left: 6%;
    z-index: 999999;
    border-radius: 4px;
    padding: 4px 8px;
    max-width: 80%;
    line-height: normal;
    background: black;
    color: white;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: break-word;
  }
  .wrap :global(.wa) {
    position: unset;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    min-width: unset;
    height: unset !important;
    background: var(--CARD1);
  }
  .large ul {
    min-height: 74px;
    max-height: 280px;
  }
  .large ul li {
    padding: 14px 20px;
    line-height: 20px;
  }
  .large input {
    width: 100%;
  }
  .large input::placeholder {
    font-size: 14px;
    color: #c5c8ce;
    opacity: 1;
  }
  .large .search-li {
    margin: 16px 14px 4px;
    border-radius: 4px;
    padding: 0;
  }
  .large .search-icon {
    top: 10px;
    left: 8px;
    width: 20px;
    height: 20px;
  }
  .large .search {
    padding-left: 36px;
    height: unset;
    line-height: 38px;
    font-size: 16px;
  }
  .h40 {
    height: 40px;
  }
  .icon-del {
    display: inline-flex;
    align-items: center;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
  }
</style>

<div
  class="wrap pr ph8 T1 {className}"
  class:ph12={type !== 'underline'}
  class:underline={type === 'underline'}
  class:border={type === 'border'}
  class:no-border={type === 'no-border'}
  class:disabled
  class:white
  class:before
  class:large={size === 'large'}
  {style}
>
  <div class="df aic jcsb h40" on:click={handleClickDownFun}>
    <slot name="displayItem" {displayText}>
      <span class:set-max-width={setMaxWidth} class="f1 cp wp100 cb ml4 wsn ooo">{displayText}</span>
    </slot>
    {#if !disabled}
      <Icon name={showDropdown ? 'selectUpFilled' : 'selectDownFilled'} width={16} height={16} />
    {/if}
  </div>
  <ul
    class="pa mt8 br8 sv"
    class:pos-left={position === 'left'}
    class:always-show-scroll-bar={alwaysShowScrollBar}
    class:pos-right={position === 'right'}
    class:dropdown={showDropdown}
    bind:this={optionsNode}
  >
    {#if options.length > showSearchMinLength}
      <li class="search-li df aic jcc pr ph10" class:no-result={filterOptionsArr?.length <= 0} class:no-search={noSearch} on:click={handleSearchClick}>
        <img class="search-icon pa" src={searchIcon} alt="search icon" />
        <input bind:this={inputEl} class="search br4" type="text" bind:value={filterValue} placeholder="Search" />
        {#if filterValue}
          <div class="icon-del dib pa" on:click|stopPropagation={handleClear}>
            <Icon name="closeOutlined" color="var(--T2)" width={20} height={20} />
          </div>
        {/if}
      </li>
    {/if}
    <li class="pr T2 cp ph10 opt-header" hidden={!showOptionHeader}>
      <slot name="optionHeader" />
    </li>
    {#each filterOptionsArr as option, index}
      <li class="pr T2 cp ph10" on:click={handleClickFun(option)} on:mouseover={handleShowHoverFun(index)} on:mouseout={handleShowLeaveFun()}>
        {#if option.text.length > 24 && showHover}
          <div class="hover pa f12" class:dn={index !== showIndex}><span>{option.text}</span></div>
        {/if}
        <slot name="item" {option}>
          <div class="f1 cp wp100 cb ml4 wsn ooo" class:active={displayText === option.text}>{option.text}</div>
        </slot>
      </li>
    {/each}
    <slot name="action" />
  </ul>
</div>
